import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';

@Injectable({
    providedIn: 'root'
})
export class GridExportService {

    exportGrid(
        gridInstance: any,
        fileName: string,
        sheetName: string,
        excludeFields: string[] = []   // 👈 new param — fields that must NEVER appear in export
    ): void {

        if (!gridInstance) {
            console.error('DataGrid instance not found!');
            return;
        }

        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet(sheetName);

        const allColumns = gridInstance.option('columns') || [];

        // Only unhide columns that are hidden in the grid AND not in the exclude list
        const hiddenColumns = allColumns
            .filter((col: any) =>
                col.visible === false &&
                col.dataField &&
                !excludeFields.includes(col.dataField)
            )
            .map((col: any) => col.dataField);

        // 🔒 Stop UI refresh
        gridInstance.beginUpdate();

        hiddenColumns.forEach((field: string) => {
            gridInstance.columnOption(field, 'visible', true);
        });

        exportDataGrid({
            component: gridInstance,
            worksheet,
            autoFilterEnabled: true,
        }).then(() => {

            hiddenColumns.forEach((field: string) => {
                gridInstance.columnOption(field, 'visible', false);
            });

            gridInstance.endUpdate();
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(
                    new Blob([buffer], { type: 'application/octet-stream' }),
                    fileName
                );
            });

        }).catch((error) => {
            gridInstance.endUpdate();
            console.error('Export failed:', error);
        });
    }
}